import { difference, isEmpty } from 'lodash';
import { CONTENT_SEARCH_IG_CHANNELS } from '~/components/ContentSearchFilter';
import { timeFrameToDays } from '~/components/ContentSearchPostedAtTimeframe/ContentSearchPostedAtTimeframe';
import { INSTAGRAM_CONTENT_TYPES } from '~/constants';
import {
  COMPARATOR_TYPES,
  Filter,
  ISearchContentParams,
  PAGE_SIZE,
} from '~/searchApi';

import {
  CONTENT_SEARCH_CHANNEL,
  CONTENT_SEARCH_ORDER_BY,
} from './useContentSearch.constants';
import { IContentSearchQuery } from './useContentSearch.types';
import {
  getAdvertisementFilter,
  getQueryFilter,
} from './useContentSearch.utils';

export const mapQueryFromVmToApi = (
  params: IContentSearchQuery,
): ISearchContentParams => {
  const {
    channel,
    creator,
    page,
    page_size,
    platform,
    roster,
    sortBy = CONTENT_SEARCH_ORDER_BY.revelance,
    fuzzy = false,
    postedAfter = null,
    postedBefore = null,
  } = params;
  const { searchQuery, hashtagFilter, mentionFilter } = getQueryFilter(params);
  const advertisementFilter = getAdvertisementFilter(params);
  const filters: Filter[] = [];

  if (advertisementFilter) {
    filters.push(advertisementFilter);
  }

  if (postedAfter) {
    let dateString = '';

    if (postedAfter in timeFrameToDays) {
      // @ts-ignore
      const days = timeFrameToDays[postedAfter];
      const date = new Date();
      date.setDate(date.getDate() - days);
      dateString = date.toISOString();
    } else {
      dateString = new Date(postedAfter).toISOString();
    }

    filters.push({
      comparator: COMPARATOR_TYPES.GT,
      name: 'published_at',
      value: dateString,
    });
  }

  if (postedBefore) {
    filters.push({
      comparator: COMPARATOR_TYPES.LT,
      name: 'published_at',
      value: new Date(postedBefore).toISOString(),
    });
  }

  if (creator) {
    filters.push({
      comparator: COMPARATOR_TYPES.EQ,
      name: 'creator_id',
      value: creator,
    });
  }

  if (hashtagFilter) {
    filters.push(hashtagFilter);
  }

  if (mentionFilter) {
    filters.push(mentionFilter);
  }

  if (channel && !isEmpty(channel)) {
    const areAllIgChannelsSelected =
      difference(CONTENT_SEARCH_IG_CHANNELS, channel).length === 0;

    if (!areAllIgChannelsSelected) {
      filters.push({
        name: 'product_type',
        comparator: COMPARATOR_TYPES.CONTAINS,
        value: channel.map(
          (c) =>
            CONTENT_SEARCH_CHANNEL[c as keyof typeof INSTAGRAM_CONTENT_TYPES],
        ),
      });
    }
  }

  return {
    filters,
    // We cannot use hooks inside the mapper function,
    //so the filter has been moved to useContentSearch hook.
    managerId: roster,
    orderBy: sortBy,
    page: parseFloat(page ?? '1'),
    pageSize: Number(page_size ?? PAGE_SIZE),
    platform: platform?.join(','),
    searchQuery,
    searchQueryFuzzyMatch: fuzzy,
  };
};
